/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('taxLegends', {
                parent: 'app',
                url: '/taxLegends?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxLegend/taxLegends.html',
                        controller: 'taxLegendCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxLegend']);
                            }],
                            taxLegends: ['taxLegendService','$stateParams', function(taxLegendService,$stateParams){
                                return taxLegendService.getPageTaxLegends($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('taxLegendNew', {
                parent: 'app',
                url: '/taxLegend/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxLegend/newTaxLegend.html',
                        controller: 'newTaxLegendCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxLegend']);
                            }]
                        }
                    }
                }
            })
            .state('taxLegendEdit', {
                parent: 'app',
                url: '/taxLegend/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxLegend/editTaxLegend.html',
                        controller: 'editTaxLegendCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxLegend']);
                            }],
                            taxLegend: ['taxLegendService', '$stateParams', function(taxLegendService, $stateParams) {
                                return taxLegendService.getTaxLegend($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('taxLegendDelete', {
                parent: 'taxLegends',
                url: '/taxLegend/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/taxLegend/deleteTaxLegend.html',
                        controller: 'deleteTaxLegendController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxLegend']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('taxLegends', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
